import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * AdminLayout Component
 * 
 * Simple layout wrapper for admin pages.
 * Does NOT fetch data - pages handle their own data fetching.
 * Uses <Outlet /> to render child routes.
 */
export function AdminLayout() {
  return (
    <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}

